// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1IP0n","title":"Info_title__1c3lw","selects":"Info_selects__1cDa2","requiredAsterisk":"Info_requiredAsterisk__1TJE0"};